import Vue from 'vue'

Vue.mixin({
  methods: {
    $notify (payload) {
      this.$store.dispatch('NOTIFY', payload)
    }
  }
})
